import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../utils/api";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { Link } from "react-router-dom";

const ThesisAdmin = () => {
  const [thesisList, setThesisList] = useState([]);
  const [category, setCategory] = useState("");

  async function exibir() {
    let payload = {};

    let url = "/thesis";

    if (category.length > 0) {
      url = url + `?category=${category}`;
    }

    if (category != null) payload = apiGet(url);
    else payload = apiGet("/thesis");

    const data = (await payload).data.data;
    return data;
  }

  useEffect(() => {
    exibir().then(
      (data) => {
        setThesisList(data);
      },
      () => {}
    );
  }, [category]);

  const onChangeHandler = async (e) => {
    const payload = apiGet("/thesis?search=" + e.target.value);
    setThesisList((await payload).data.data);
  };

  function deleteThesis(id) {
    deleteById(id).then(
      (payload) => {
        alert("Elemento removido!", "success");

        setThesisList(thesisList.filter((item) => item.thesis_id !== id));
      },
      (error) => {
        let message = "Erro ao remover!";

        if (error.status === 401) {
          message = "Sem autorização.";
          // toLogin();
        }
        alert(message, "error");
      }
    );
  }

  async function deleteById(id) {
    const payload = apiPost("/thesis/delete/" + id);
    return await payload;
  }

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Teses e Dissertações</h2>
        </div>

        <div className="row m-1">
          <div>
            <Link to="/management/thesis/create" className="btn btn-primary">
              Cadastrar Tese ou Dissertação
            </Link>
            &nbsp;&nbsp;&nbsp;
            <Link className="btn btn-secondary" to={"/management"}>
              Voltar
            </Link>
          </div>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
              <InputLabel id="select-label">Categoria</InputLabel>
              <Select
                labelId="select-label"
                id="simple-select"
                value={category}
                label="Categoria"
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >
                <MenuItem value="">
                  <em>Todas</em>
                </MenuItem>
                <MenuItem value={"Dissertação"}>
                  Dissertações de mestrado
                </MenuItem>
                <MenuItem value={"Tese"}>Teses de doutorado</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <div className="search">
              <input
                type="text"
                onChange={(e) => onChangeHandler(e)}
                placeholder="Pesquise aqui..."
              />
            </div>
          </div>
        </div>

        {thesisList && thesisList.length ? (
          thesisList.map((thesis) => {
            return (
              <div className="row mx-5 posts" key={thesis.thesis_id}>
                <div className="card mb-3">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card-body">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <b>Título:</b>
                              </td>
                              <td>{thesis.title}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Tipo:</b>
                              </td>
                              <td>{thesis.type}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Ano:</b>
                              </td>
                              <td>{thesis.year}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Autor(a):</b>
                              </td>
                              <td>{thesis.author}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={thesis.access_link}
                                >
                                  Acessar o trabalho
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <div>
                          <Link
                            to={`/management/thesis/edit/${thesis.thesis_id}`}
                            className="btn btn-success"
                          >
                            Editar
                          </Link>
                          &nbsp;&nbsp;&nbsp;
                          <button
                            onClick={() => deleteThesis(thesis.thesis_id)}
                            className="btn btn-primary"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="row mx-5 posts">
            <div className="card mb-3">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card-body">
                    <h5 className="card-title">
                      Nenhum trabalho para esta pesquisa.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default ThesisAdmin;
